import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-end-page',
  templateUrl: './end-page.component.html',
  styleUrls: ['./end-page.component.css']
})
export class EndPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
